module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lightningIcon_02d291.png";